import { AuxButton } from "@blk/aladdin-react-components-es";
import { AuxButtonSizeEnum, AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import { saveAs } from "file-saver";
import { isEqual } from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { requestAsync } from "redux-query";
import { generate } from "short-uuid";
import { getDownloadFileConfig } from "../cashflow-forecast/ins-cashflow-requests-config";
import { publicEquityIndicesGridState } from "./insPublicEquityIndicesContent";
import { exportPmis } from "api/admin/src";
import { language } from "language/default";
export const InsPublicEquityIndicesExport = () => {
    const indicesLang = language.en.administration.marketDataAdministration.indices;
    const dispatch = useDispatch();
    const [requestKey, setRequestKey] = useState(""), exportedToExcel = useSelector((s) => s.entities?.PmiFile?.[requestKey], isEqual), selectedRows = useSelector((state) => state.grids.state[publicEquityIndicesGridState]?.selectedRows, isEqual);
    const doExport = () => {
        if ((selectedRows?.length ?? 0) > 0) {
            const newRequestKey = generate().toString();
            setRequestKey(newRequestKey);
            dispatch(requestAsync(getDownloadFileConfig({ exportPmi: selectedRows ?? [], id: newRequestKey }, "PmiFile", (params, config) => exportPmis(params, config))));
        }
    };
    useEffect(() => {
        if (requestKey && exportedToExcel) {
            saveAs(exportedToExcel, `IndexPriceHistory-${requestKey}.xlsx`);
            setRequestKey("");
        }
    }, [exportedToExcel, requestKey]);
    return React.createElement(AuxButton, { icon: "download", type: AuxButtonTypeEnum.SECONDARY, size: AuxButtonSizeEnum.SMALL, label: indicesLang.equityIndices.exportIndices, isDisabled: (selectedRows?.length ?? 0) === 0, onClick: () => {
            doExport();
        } });
};
